// Module
var code = "<h2 id=\"direct-debit\">Direct Debit</h2> <p>Learn about the benefits of setting up automatics payments and how to sign up. </p> ";
// Exports
export default code;